// extracted by mini-css-extract-plugin
module.exports = {"timer-container":"timer_timer-container__FioqD","timer-text":"timer_timer-text__3jQKr","timer-content":"timer_timer-content__vgDLk","time-reminder":"timer_time-reminder__8ePH2"};